// extracted by mini-css-extract-plugin
export var label = "_71-1";
export var reminder = "_71-0";